__turbopack_context__.v({
  "arrowIcon": "xxwttW_arrowIcon",
  "drawerItem": "xxwttW_drawerItem",
  "drawerItemactive": "xxwttW_drawerItemactive",
  "drawerItemexpanded": "xxwttW_drawerItemexpanded",
  "drawerItemwithAccordion": "xxwttW_drawerItemwithAccordion",
  "icon": "xxwttW_icon",
  "iconexpanded": "xxwttW_iconexpanded",
  "iconwithAccordion": "xxwttW_iconwithAccordion",
  "itemWrapper": "xxwttW_itemWrapper",
  "itemWrapperexpanded": "xxwttW_itemWrapperexpanded",
  "itemWrapperwithAccordion": "xxwttW_itemWrapperwithAccordion",
  "mobileDrawerItemSubItem": "xxwttW_mobileDrawerItemSubItem",
  "submenu": "xxwttW_submenu",
  "submenuexpanded": "xxwttW_submenuexpanded",
  "text": "xxwttW_text",
  "textWrapper": "xxwttW_textWrapper",
  "textactive": "xxwttW_textactive",
  "textexpanded": "xxwttW_textexpanded",
  "textwithAccordion": "xxwttW_textwithAccordion",
});
